import React, {useState} from 'react';
import fullNameStyle from '../style';

export default function FullName(props) {
	let style = fullNameStyle();
	let [first, setFirst] = useState(null);
	let [last, setLast] = useState(null);

	return (
		<div className='row' style={style.fullNameContainer()}>
			<div className='col-md-6' style={style.inputCol({half: 'left'})}>
				<p>First name</p>
				<input
					style={style.input()}
					placeholder='John'
					type='text'
					onChange={e => {
						inputChanged(e, 'first');
					}}
				/>
			</div>
			<div className='col-md-6 mt-3 mt-md-0' style={style.inputCol({half: 'right'})}>
				<p>Last name</p>
				<input
					style={style.input()}
					placeholder='Thompson'
					type='text'
					onChange={e => {
						inputChanged(e, 'last');
					}}
				/>
			</div>
			<button style={style.nextNameButton()} onClick={nextPressed}>
				Next
			</button>
		</div>
	);

	function inputChanged(event, fL) {
		let value = event.target.value;
		if (fL === 'first') {
			setFirst(value);
		} else if (fL === 'last') {
			setLast(value);
		}
	}

	function nextPressed() {
		props.nextPressed(first, last);
	}
}
